import { placeService } from '@/services';
import { Place } from '@/types/state/shared';
import { useEffect, useState } from 'react';

export const useDealReviews = (placeId: number | undefined, displayReviews: boolean) => {
  const [reviewsData, setReviewListItems] = useState<Place['reviews'] | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!placeId || !displayReviews) return;
    let cancelled = false;
    setIsFetching(true);
    placeService
      .getPlaceReviews(placeId, true)
      .then((response) => {
        if (cancelled) return;
        setReviewListItems(response?.reviews ?? null);
      })
      .catch(() => {
        if (cancelled) return;
        setReviewListItems(null);
      })
      .finally(() => {
        if (!cancelled) setIsFetching(false);
      });
    return () => {
      cancelled = true;
    };
  }, [placeId, displayReviews]);

  return { reviewsData, isFetching };
};
